'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

/**
 * Sonner registra un `useSyncExternalStore` global que, en algunos navegadores
 * y versiones de React, provoca el aviso de hydration #329 ("Suspense boundary
 * received an update before it finished hydrating") al actualizarse durante el
 * montaje inicial. Lo retrasamos hasta despues de la hidratacion para que el
 * arbol no se vea afectado.
 */
export function ClientToaster() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <Toaster
      theme="dark"
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'bg-navy-900 border border-gold-500/30 text-cream backdrop-blur-md',
          title: 'text-cream font-medium',
          description: 'text-cream/70',
        },
      }}
    />
  );
}
